import { AxiosInstance } from 'axios';
import ApiClient from './ApiClient';
import { PaymentMethodAvailability } from '../types/Payment/PaymentMethodAvailability';
import { PaymentSettings } from '../types/Payment/PaymentSettings';
import { Payments } from '../types/Payment/Payment';
import PaymentMethod = Payments.PaymentMethod;

export default class PaymentSettingsService extends ApiClient {
  private static get paymentSettingsClient(): AxiosInstance {
    return this.client;
  }

  public static async getAvailablePaymentMethods(): Promise<PaymentMethodAvailability[]> {
    let res = await this.paymentSettingsClient.request<PaymentMethodAvailability[]>({
      method: 'GET',
      url: this.apiDomain + '/payment-settings/available-payment-methods',
    });
    return res.data;
  }

  public static async getPaymentSettings(): Promise<PaymentSettings> {
    let res = await this.paymentSettingsClient.request<PaymentSettings>({
      method: 'GET',
      url: this.apiDomain + '/payment-settings',
    });
    return res.data;
  }

  public static async enablePaymentMethod(paymentMethod: PaymentMethod): Promise<void> {
    await this.paymentSettingsClient.request({
      method: 'POST',
      url: this.apiDomain + '/payment-settings',
      params: {
        paymentMethod: paymentMethod
      }
    })
  }

  public static async disablePaymentMethod(paymentMethod: PaymentMethod): Promise<void> {
    await this.paymentSettingsClient.request({
      method: 'DELETE',
      url: this.apiDomain + '/payment-settings',
      params: {
        paymentMethod: paymentMethod
      }
    })
  }
}
